import React from "react";

export const Card = ({ title, features, iconClass = null, image = null }) => {
    return (
        <div className="card border-0 shadow-sm rounded-4 p-3 text-center h-100" style={{ maxWidth: "20rem" }}>
            <div className="card-body d-flex flex-column align-items-center">
                {iconClass && (
                    <div className="text-primary mb-3">
                        <i className={iconClass} style={{ fontSize: "3rem" }}></i>
                    </div>
                )}

                {image && (
                    <img
                        src={image.image}
                        alt={image.alt}
                        className="img-fluid mb-3 rounded"
                        style={{ maxHeight: "100px", objectFit: "contain" }}
                    />
                )}

                <h5 className="card-title fw-bold text-primary mb-3">{title}</h5>

                <ul className="list-unstyled text-start px-2">
                    {Array.isArray(features) ? (
                        features.map((feature, index) => (
                            <li key={index} className="mb-2">
                                ✅ {feature}
                            </li>
                        ))
                    ) : (
                        <li>{features}</li>
                    )}
                </ul>
            </div>
        </div>
    );
};
